import React from 'react';
import { Drawer } from 'antd';
import { CodeOutlined, ExportOutlined, GlobalOutlined, HistoryOutlined, ReadOutlined, RobotOutlined, UnlockOutlined, WhatsAppOutlined, } from '@ant-design/icons';
import { MdArrowBack } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { HELP_CENTER_API_REFERENCE_URLS, HELP_CENTER_BOT_DOCUMENTATION_URL, HELP_CENTER_CHANGELOG_URL, HELP_CENTER_URLS, TEXTER_WHATSAPP_SUPPORT_URL, } from '../constants';
import { getDirection } from '../helpers';
import drawerStyles from './SettingsDrawer/SettingsDrawer.module.scss';
import styles from './HelpDrawer.module.scss';
const HelpDrawer = ({ isOpen, onClose }) => {
    var _a, _b;
    const { t, i18n } = useTranslation();
    const isRtl = getDirection() === 'rtl';
    const language = i18n.language.toLowerCase().split('-')[0];
    const links = [
        {
            label: t('helpGuides'),
            url: (_a = HELP_CENTER_URLS[language]) !== null && _a !== void 0 ? _a : HELP_CENTER_URLS.en,
            icon: React.createElement(ReadOutlined, { "aria-hidden": true }),
        },
        {
            label: t('helpApiReference'),
            url: (_b = HELP_CENTER_API_REFERENCE_URLS[language]) !== null && _b !== void 0 ? _b : HELP_CENTER_API_REFERENCE_URLS.en,
            icon: React.createElement(CodeOutlined, { "aria-hidden": true }),
        },
        {
            label: t('helpBotDocumentation'),
            url: HELP_CENTER_BOT_DOCUMENTATION_URL,
            icon: React.createElement(RobotOutlined, { "aria-hidden": true }),
        },
        {
            label: t('helpChangelog'),
            url: HELP_CENTER_CHANGELOG_URL,
            icon: React.createElement(HistoryOutlined, { "aria-hidden": true }),
        },
    ];
    const aboutLinks = [
        { label: t('website'), url: 'https://texterchat.com', icon: React.createElement(GlobalOutlined, { "aria-hidden": true }) },
        { label: t('terms'), url: 'https://texterchat.com/terms', icon: React.createElement(ReadOutlined, { "aria-hidden": true }) },
        { label: t('privacyPolicy'), url: 'https://texterchat.com/privacy', icon: React.createElement(UnlockOutlined, { "aria-hidden": true }) },
    ];
    return (React.createElement(Drawer, { className: classNames(drawerStyles.drawer, { [drawerStyles.rtl]: isRtl }), open: isOpen, onClose: onClose, placement: isRtl ? 'right' : 'left', width: 320, title: t('tooltipHelp'), bodyStyle: { padding: 0 }, closeIcon: React.createElement(MdArrowBack, { className: drawerStyles.closeIcon }) },
        React.createElement("nav", { className: styles.content, "aria-label": t('tooltipHelp') },
            React.createElement("ul", { className: styles.links }, links.map(({ label, url, icon }) => (React.createElement("li", { key: url },
                React.createElement("a", { className: styles.link, href: url, target: "_blank", rel: "noopener noreferrer" },
                    React.createElement("span", { className: styles.icon }, icon),
                    React.createElement("span", { className: styles.label }, label),
                    React.createElement(ExportOutlined, { className: styles.externalIcon, "aria-hidden": true })))))),
            React.createElement("div", { className: styles.supportSection },
                React.createElement("a", { className: styles.supportLink, href: TEXTER_WHATSAPP_SUPPORT_URL, target: "_blank", rel: "noopener noreferrer" },
                    React.createElement(WhatsAppOutlined, { className: styles.supportIcon, "aria-hidden": true }),
                    React.createElement("span", null, t('helpSupport')),
                    React.createElement(ExportOutlined, { className: styles.supportExternalIcon, "aria-hidden": true }))),
            React.createElement("section", { className: styles.aboutSection, "aria-label": t('panelAbout') },
                React.createElement("h2", { className: styles.sectionTitle }, t('panelAbout')),
                React.createElement("ul", { className: styles.links }, aboutLinks.map(({ label, url, icon }) => (React.createElement("li", { key: url },
                    React.createElement("a", { className: styles.link, href: url, target: "_blank", rel: "noopener noreferrer" },
                        React.createElement("span", { className: styles.icon }, icon),
                        React.createElement("span", { className: styles.label }, label),
                        React.createElement(ExportOutlined, { className: styles.externalIcon, "aria-hidden": true }))))))))));
};
export default HelpDrawer;
